<!-- LOGIN SECTION -->
<div class="header-login">
  <div class="login-container">
    <div class="logo-user">
      <button class="login-logo" disabled>
        {{ store.user?.userName === " " ? store.user?.emailAddress[0] : store.user?.userName[0] }}
      </button>
    </div>
    <div class="login-informations">
      <div class="login-name">{{ store.user?.userName }}</div>
      <div class="mail">{{ store.user?.emailAddress }}</div>
    </div>
    <div class="offline-logo hide"></div>
    <div class="cross-logo">
      <mat-icon class="icon icon-close on_background" (click)="close()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <div class="user-auth">
    <div class="mat-button hide"></div>
    <div class="mat-button">
      @if (store.isLoggedIn) {
        <div class="login-link" (click)="logout()" oPlayId pidValue="logout-btn">
          <span>{{ "logout.title" | translate }}</span>
          <mat-icon svgIcon="logout" class="log-icon on_background" />
        </div>
      } @else {
        <div class="login-link" (click)="login()" oPlayId pidValue="login-btn">
          <span>{{ "login.label" | translate }}</span>
          <mat-icon svgIcon="login" class="log-icon on_background" />
        </div>
      }
    </div>
  </div>
</div>
<!-- END LOGIN  -->

<div class="header">
  <div class="logo-items">
    @if (store.pubInfo?.capabilities?.bookmarks) {
      @if (canBeBookmarked && makeBookmarks) {
        <mat-icon
          class="icon icon-bookmark-add"
          (click)="createBookmarks()"
          color="primary"
          [svgIcon]="isBookmarked ? 'bookmark-add' : 'bookmark-add-outline'"></mat-icon>
      } @else if (!canBeBookmarked) {
        <mat-icon class="icon icon-bookmark not-clickable" color="primary" svgIcon="bookmark-outline"></mat-icon>
      }
    }
    @if (store.pubInfo?.capabilities?.notes && makePrivateNote) {
      <mat-icon
        [ngClass]="{ 'not-clickable': !canHaveNotes || !!noteService.editingNote() }"
        class="icon icon-note"
        (click)="createNote()"
        color="primary"
        svgIcon="note-plus"></mat-icon>
    }
    @if (store.isGov) {
      <mat-icon
        [class.not-clickable]="!store.offlineSearchReady"
        class="icon icon-comment-add"
        [matMenuTriggerFor]="commentMenu"
        color="primary"
        svgIcon="comment-add">
      </mat-icon>
    }
    <mat-icon color="primary" class="icon icon-print" svgIcon="print" (click)="print()"></mat-icon>
    <!-- SPEC: Hide PYM button for user that don't have access to PYM issue GitLab 1756 -->
    @if (store.pubInfo?.capabilities?.pym && makePym) {
      <mat-icon
        [ngClass]="{ 'not-clickable': !canBePym }"
        color="primary"
        class="icon icon-pym"
        svgIcon="file-tree"
        (click)="openPymModal()"></mat-icon>
    }
    <mat-icon
      [ngClass]="{ 'not-clickable': !store.duStatus || !canBeBookmarked }"
      color="primary"
      class="icon icon-info"
      svgIcon="info"
      (click)="openInfoDialog()"></mat-icon>
    @if (store.pubInfo?.capabilities?.maintFolder) {
      <mat-icon
        [ngClass]="{ 'not-clickable': !canDoMaintFolder || !maintFolderService.referencesMap?.[store.currentDMC] }"
        color="primary"
        class="icon"
        svgIcon="graph"
        (click)="openMaintFolderModal()"></mat-icon>
    }
  </div>
</div>

<!-- App deterioration warning -->
@if (store.deteriorate) {
  <div class="deteriorate-warning">
    {{ "degradation.disclaimer" | translate }}
  </div>
}

<mat-list>
  <div class="matlist--top">
    <!-- TOC-ITEMS -->
    @if (store.pubInfo?.capabilities?.bookmarks) {
      <mat-list-item class="item-clickable item-bookmark" (click)="close()" [routerLink]="'./bookmark'">
        <mat-icon color="primary" svgIcon="bookmarks"></mat-icon>
        {{ "settings.bookmarks" | translate }}
      </mat-list-item>
    }
    @if (store.pubInfo?.capabilities?.maintFolder) {
      <mat-list-item class="item-clickable item-folders" (click)="close()" [routerLink]="'./maintenance-folders'">
        <mat-icon color="primary" svgIcon="graph"></mat-icon>
        {{ "settings.maint.folders" | translate }}
      </mat-list-item>
    }
    @if (store.pubInfo?.capabilities?.notes) {
      <mat-list-item class="item-clickable item-notes" (click)="close()" [routerLink]="'./notes'">
        <mat-icon color="primary" svgIcon="notes"></mat-icon>
        {{ "settings.notes" | translate }}
      </mat-list-item>
    }
    @if (store.isGov) {
      <mat-list-item class="item-clickable item-comments" (click)="close()" [routerLink]="'./comments'">
        <mat-icon color="primary" svgIcon="comment"></mat-icon>
        {{ "settings.comments" | translate }}
      </mat-list-item>
    }
    @if (store.pubInfo?.capabilities?.inspections && store.pubInfo?.capabilities?.search?.task) {
      <mat-list-item class="item-clickable" (click)="close()" [routerLink]="'./inspections'">
        <mat-icon color="primary" svgIcon="agenda"></mat-icon>
        {{ "search.facets.inspection" | translate }}
      </mat-list-item>
    }
    @if (store.pubInfo?.capabilities["shopping-basket"]) {
      <mat-list-item class="item-clickable item-basket" (click)="close()" [routerLink]="'./shopping'">
        <mat-icon color="primary" svgIcon="shopping-basket"></mat-icon>
        {{ "settings.shopping" | translate }}
      </mat-list-item>
    }

    <!-- Actions -->
    @if (store.pubInfo?.capabilities?.sync) {
      <mat-list-item
        [class.item-clickable]="store.isLoggedIn && !store.deteriorate"
        [class.not-clickable]="!store.isLoggedIn || store.deteriorate"
        (click)="synchronize()"
        [disabled]="!store.isLoggedIn || store.deteriorate">
        <mat-icon color="primary" svgIcon="autorenew"></mat-icon>
        {{ "settings.synchronize" | translate }}
      </mat-list-item>
    }

    <!-- Additional documents -->
    @if (!store.pubInfo?.isPackagePDF) {
      <mat-list-item
        class="item-clickable item-additional-documents"
        (click)="close()"
        [routerLink]="'./additional-documents'">
        <mat-icon color="primary" svgIcon="multiple-docs"></mat-icon>
        {{ "settings.additionalDoc.label" | translate }}
      </mat-list-item>
    }

    <!-- Setting -->
    <mat-list-item class="settings-item item-clickable" (click)="openSettings()">
      <mat-icon color="primary" svgIcon="settings"></mat-icon>{{ "settings.title" | translate }}
    </mat-list-item>

    <!-- Help -->
    <mat-list-item class="item-clickable" (click)="close()" [routerLink]="'./help'">
      <mat-icon color="primary" svgIcon="help-circle"></mat-icon>
      {{ "help" | translate }}
    </mat-list-item>
  </div>
</mat-list>

<mat-menu #commentMenu="matMenu">
  <button mat-menu-item (click)="createComment(commentLocation.APP)">
    {{ "comments.location." + commentLocation.APP | translate }}
  </button>
  <button mat-menu-item (click)="createComment(commentLocation.PUB)">
    {{ "comments.location." + commentLocation.PUB | translate }}
  </button>
  <button mat-menu-item [disabled]="!canHaveComments" (click)="createComment(commentLocation.PM)">
    {{ "comments.location." + commentLocation.PM | translate }}
  </button>
  <button mat-menu-item [disabled]="!canHaveComments" (click)="createComment(commentLocation.DM)">
    {{ "comments.location." + commentLocation.DM | translate }}
  </button>
</mat-menu>
